<div class="header">
  <inf-actions-bar [config]="actionBarConfig" [title]="title" [actions]="actionsGroup" (actionClick)="onClickAction($event)"/>
</div>
<div class="content">
  <inf-form #form [model]="model" [entity]="entity"/>
</div>

